"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const recyclingbrand03 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-recyclingbrand03` : '') + (description ? ` desc-recyclingbrand03` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-recyclingbrand03"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-recyclingbrand03"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.73 62.47h-1.9c-3.12 0-6.01-1.62-7.65-4.28l-.15-.24a9.101 9.101 0 0 1 0-9.06c-.67.94.13-.57 2.4-4.53 2.27-3.96 7.96-13.77 17.07-29.44l3.17-5.53a8.975 8.975 0 0 1 7.79-4.54c3.21 0 6.19 1.73 7.79 4.54l15.98 28.23L64 42.1l3.9 6.79a9.101 9.101 0 0 1 0 9.06 8.998 8.998 0 0 1-7.79 4.53H16.73v-.01Z",
    fill: "#FFB499",
    fillOpacity: ".5",
    opacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fill: "#F04C24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.88 38.32c-.44 0-.85-.3-.97-.75l-3.03-11.5-11.31 3.08a.999.999 0 0 1-1.23-.7c-.15-.53.17-1.08.7-1.23l12.29-3.34a1.007 1.007 0 0 1 1.23.71l3.29 12.48c.14.53-.18 1.08-.71 1.22-.09.02-.17.03-.26.03Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.99 60.1c-3.56 0-6.88-1.94-8.66-5.07-1.78-3.12-1.78-7 0-10.12l11.39-20.54c.27-.48.88-.66 1.36-.39.48.27.66.88.39 1.36L4.07 45.88a8.297 8.297 0 0 0 0 8.16c1.42 2.5 4.08 4.06 6.92 4.06h9.15c.55 0 1 .45 1 1s-.45 1-1 1h-9.16.01Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.68 37.68a.996.996 0 0 1 1.36.37l3.9 6.85c1.78 3.13 1.78 6.99 0 10.12-1.78 3.13-5.08 5.07-8.66 5.07H33.62c-.55 0-1-.45-1-1s.45-1 1-1h22.66c2.85 0 5.49-1.54 6.92-4.06a8.278 8.278 0 0 0 0-8.15l-3.9-6.85a.996.996 0 0 1 .37-1.36l.01.01Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.32 49.25c.39.39.4 1.02.01 1.41l-8.3 8.43 8.3 8.43a.996.996 0 1 1-1.42 1.4l-8.99-9.13c-.38-.39-.38-1.01 0-1.4l8.99-9.13a.996.996 0 0 1 1.41-.01ZM56.36 12.46c.53.14.85.69.71 1.22l-3.29 12.48c-.07.26-.24.48-.47.61-.23.13-.51.17-.76.1l-12.28-3.34a.999.999 0 0 1-.7-1.23c.15-.54.69-.85 1.23-.7l11.31 3.08 3.03-11.5c.14-.53.69-.85 1.22-.71v-.01Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.96 5.08C26.74 1.94 30.04 0 33.62 0s6.88 1.94 8.66 5.08l11.39 20.35a1 1 0 0 1-1.74.98L40.54 6.07C39.11 3.55 36.47 2 33.62 2c-2.85 0-5.49 1.55-6.92 4.07l-3.17 5.57c-.27.48-.88.65-1.36.37a.988.988 0 0 1-.37-1.36l3.17-5.57h-.01Z"
  })));
};
var _default = exports.default = recyclingbrand03;